import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

import { TabNode } from '../insight/experimental.tabset';
import { PopUpService } from '../insight/pop-up.service';

@Component({
    selector: '[cmpsInsightExplorerTabRename]',
    template: ` <div
        role="form"
        [formGroup]="form"
    >
        <input
            type="text"
            class="form-control mb-3"
            formControlName="value"
            (keyup.enter)="onRenameClick()"
        />
        <div class="text-nowrap">
            <button
                class="btn btn-primary"
                (click)="onCancelClick()"
            >
                Cancel
            </button>
            <button
                class="btn btn-primary active"
                (click)="onRenameClick()"
            >
                Rename
            </button>
        </div>
    </div>`,
})
export class TabRenameInsightExplorerComponent {
    form: FormGroup;
    private _id: string;

    // eslint-disable-next-line accessor-pairs
    set tab(value: TabNode) {
        this._id = value.def.id;
        this.form.patchValue(
            { value: value.def.ctx.label },
            { emitEvent: false },
        );
    }

    constructor(
        private readonly _formBuilder: FormBuilder,
        private readonly _popUpService: PopUpService,
    ) {
        this.form = this._formBuilder.group({
            value: [null],
        });
    }

    onCancelClick(): void {
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        this._popUpService.active && this._popUpService.active.dismiss();
    }

    onRenameClick(): void {
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        this._popUpService.active &&
            this._popUpService.active.close({
                id: this._id,
                // eslint-disable-next-line @typescript-eslint/dot-notation
                label: this.form.value['value'],
            });
    }
}
